export const APPOINTMENTS_QUERY_KEY = ['appointments'] as const;
export const OWN_UPCOMING_APPOINTMENTS_QUERY_KEY = ['ownUpcomingAppointments'] as const;
export const CURRENT_USER_QUERY_KEY = ['currentUser'] as const;
export const CURRENT_USER_ACCESS_QUERY_KEY = ['currentUserAccess'] as const;
export const PERMISSIONS_QUERY_KEY = ['permissions'] as const;
export const ROLES_QUERY_KEY = ['roles'] as const;
export const PLATFORM_USERS_QUERY_KEY = ['platformUsers'] as const;
export const INVITATIONS_QUERY_KEY = ['invitations'] as const;
export const TENANTS_QUERY_KEY = ['tenants'] as const;
export const TENANT_MODULES_QUERY_KEY = ['tenantModules'] as const;
export const WORKSPACE_BRANDING_QUERY_KEY = ['workspaceBranding'] as const;
export const CLIENTS_QUERY_KEY = ['clients'] as const;
export const PATIENTS_QUERY_KEY = ['patients'] as const;
export const WORKSPACE_PATIENT_OPTIONS_QUERY_KEY = ['workspacePatientOptions'] as const;
export const OWN_PET_SPECIES_OPTIONS_QUERY_KEY = ['ownPetSpeciesOptions'] as const;
export const TREATMENT_CATEGORIES_QUERY_KEY = ['treatmentCategories'] as const;
export const BODY_AREAS_QUERY_KEY = ['bodyAreas'] as const;
export const TREATMENT_DEVICES_QUERY_KEY = ['treatmentDevices'] as const;
export const TREATMENTS_QUERY_KEY = ['treatments'] as const;
export const OWN_CLIENT_PROFILE_QUERY_KEY = ['ownClientProfile'] as const;
export const OWN_CONSENTS_QUERY_KEY = ['ownConsents'] as const;
export const OWN_CARE_HISTORY_QUERY_KEY = ['ownCareHistory'] as const;
export const OWN_TREATMENT_PLANS_QUERY_KEY = ['ownTreatmentPlans'] as const;
export const AUDIT_LOGS_QUERY_KEY = ['auditLogs'] as const;
export const WORKSPACE_AUDIT_LOGS_QUERY_KEY = ['workspaceAuditLogs'] as const;
export const WORKSPACE_EMAIL_LOG_QUERY_KEY = ['workspaceEmailLog'] as const;

export function buildWorkspaceEmailLogEntryQueryKey(entryId: string) {
  return [...WORKSPACE_EMAIL_LOG_QUERY_KEY, 'entry', entryId] as const;
}

export const PLATFORM_METRICS_SUMMARY_QUERY_KEY = ['platformMetricsSummary'] as const;
export const PLATFORM_METRICS_GROWTH_QUERY_KEY = ['platformMetricsGrowth'] as const;
export const PLATFORM_METRICS_ACTIVITY_QUERY_KEY = ['platformMetricsActivity'] as const;
export const PLATFORM_METRICS_BREAKDOWN_QUERY_KEY = ['platformMetricsBreakdown'] as const;
export const ORGANIZATION_QUERY_KEY = ['organization'] as const;

export function buildWorkspaceTeamMembersQueryKey(tenantId: string | null) {
  return ['workspaceTeamMembers', tenantId] as const;
}

export function buildWorkspaceInvitationsQueryKey(tenantId: string | null, page: number) {
  return ['workspaceInvitations', tenantId, page] as const;
}
export const CONSULTATION_INTAKE_FIELDS_QUERY_KEY = ['consultationIntakeFields'] as const;
export const CONSULTATION_OUTCOME_OPTIONS_QUERY_KEY = ['consultationOutcomeOptions'] as const;
export const PRE_VISIT_QUESTIONS_QUERY_KEY = ['preVisitQuestions'] as const;
export const OWN_PRE_VISIT_QUESTIONS_QUERY_KEY = ['ownPreVisitQuestions'] as const;
export const TREATMENT_PLAN_TEMPLATES_QUERY_KEY = ['treatmentPlanTemplates'] as const;
export const CONSENT_DOCUMENTS_QUERY_KEY = ['consentDocuments'] as const;
export const CALENDAR_CONNECTION_QUERY_KEY = ['calendarConnection'] as const;
export const EXTERNAL_CALENDAR_EVENTS_QUERY_KEY = ['externalCalendarEvents'] as const;
export const NOTIFICATIONS_QUERY_KEY = ['notifications'] as const;
export const NOTIFICATIONS_UNREAD_COUNT_QUERY_KEY = ['notificationsUnreadCount'] as const;
export const NOTIFICATION_PREFERENCES_QUERY_KEY = ['notificationPreferences'] as const;
export const NOTIFICATION_PROVIDERS_QUERY_KEY = ['notificationProviders'] as const;
export const UNSUBSCRIBE_STATUS_QUERY_KEY = ['unsubscribeStatus'] as const;
export const LEGAL_DOCUMENT_QUERY_KEY = ['legalDocument'] as const;
export const PENDING_LEGAL_DOCUMENTS_QUERY_KEY = ['pendingLegalDocuments'] as const;
export const SERVICES_QUERY_KEY = ['services'] as const;
export const OWN_SERVICES_QUERY_KEY = ['ownServices'] as const;
export const REPORTS_SUMMARY_QUERY_KEY = ['reportsSummary'] as const;
export const REPORTS_VISITS_BY_TYPE_QUERY_KEY = ['reportsVisitsByType'] as const;
export const REPORTS_VISITS_BY_STATUS_QUERY_KEY = ['reportsVisitsByStatus'] as const;
export const REPORTS_TREATMENTS_DELIVERED_QUERY_KEY = ['reportsTreatmentsDelivered'] as const;
export const OWN_INTAKE_SUBMISSIONS_QUERY_KEY = ['ownIntakeSubmissions'] as const;
export const WORKSPACE_INTAKE_SUBMISSIONS_QUERY_KEY = ['workspaceIntakeSubmissions'] as const;
export const OWN_ANNOUNCEMENTS_QUERY_KEY = ['ownAnnouncements'] as const;
export const CHAT_CONVERSATIONS_QUERY_KEY = ['chatConversations'] as const;
export const CHAT_MESSAGES_QUERY_KEY = ['chatMessages'] as const;
export const CHAT_UNREAD_COUNT_QUERY_KEY = ['chatUnreadCount'] as const;

export const SUPPORT_TICKETS_QUERY_KEY = ['supportTickets'] as const;
export const SUPPORT_TICKET_DETAIL_QUERY_KEY = ['supportTicketDetail'] as const;
export const SUPPORT_MESSAGES_QUERY_KEY = ['supportMessages'] as const;
export const SUPPORT_UNREAD_COUNT_QUERY_KEY = ['supportUnreadCount'] as const;

export function buildSupportTicketsQueryKey(
  scope: string,
  page: number,
  search: string,
  status: string | null,
  assigneeUserId: string | null,
  unassigned: boolean
): readonly (string | number | boolean | null)[] {
  return [...SUPPORT_TICKETS_QUERY_KEY, scope, page, search, status, assigneeUserId, unassigned];
}

export function buildSupportTicketDetailQueryKey(
  scope: string,
  ticketId: string
): readonly string[] {
  return [...SUPPORT_TICKET_DETAIL_QUERY_KEY, scope, ticketId];
}

export function buildSupportMessagesQueryKey(scope: string, ticketId: string): readonly string[] {
  return [...SUPPORT_MESSAGES_QUERY_KEY, scope, ticketId];
}

export function buildSupportUnreadCountQueryKey(scope: string): readonly string[] {
  return [...SUPPORT_UNREAD_COUNT_QUERY_KEY, scope];
}

export function buildChatConversationsQueryKey(
  scope: string,
  page: number,
  search: string
): readonly (string | number)[] {
  return [...CHAT_CONVERSATIONS_QUERY_KEY, scope, page, search];
}

export function buildChatMessagesQueryKey(
  scope: string,
  conversationId: string
): readonly string[] {
  return [...CHAT_MESSAGES_QUERY_KEY, scope, conversationId];
}

export function buildChatUnreadCountQueryKey(scope: string): readonly string[] {
  return [...CHAT_UNREAD_COUNT_QUERY_KEY, scope];
}

export function buildChatConversationByIdQueryKey(conversationId: string): readonly string[] {
  return [...CHAT_CONVERSATIONS_QUERY_KEY, 'byId', conversationId];
}

export function buildConsentDocumentQueryKey(documentId: string): readonly string[] {
  return ['consentDocuments', documentId];
}

export function buildRoleQueryKey(roleId: string): readonly string[] {
  return ['roles', roleId];
}

export function buildTenantQueryKey(tenantId: string): readonly string[] {
  return ['tenants', tenantId];
}

export function buildTenantModulesQueryKey(tenantId: string): readonly string[] {
  return ['tenantModules', tenantId];
}

export function buildTenantMembersQueryKey(tenantId: string): readonly string[] {
  return ['tenantMembers', tenantId];
}

export function buildClientQueryKey(clientId: string): readonly string[] {
  return ['clients', clientId];
}

export function buildClientPatientsQueryKey(clientId: string): readonly string[] {
  return ['clients', clientId, 'patients'];
}

export function buildClientConsentsQueryKey(clientId: string): readonly string[] {
  return ['clients', clientId, 'consents'];
}

export const CONSENTS_OVERVIEW_QUERY_KEY = ['consentsOverview'] as const;

export function buildConsentsOverviewQueryKey(
  page: number,
  search: string,
  overviewFilter: string
): readonly (string | number)[] {
  return [...CONSENTS_OVERVIEW_QUERY_KEY, page, search, overviewFilter];
}

export function buildPatientQueryKey(patientId: string): readonly string[] {
  return ['patients', patientId];
}

export function buildPatientTimelineQueryKey(patientId: string): readonly string[] {
  return ['patients', patientId, 'timeline'];
}

export function buildPatientSessionNotesQueryKey(patientId: string): readonly string[] {
  return ['patients', patientId, 'sessionNotes'];
}

export function buildPatientPerformedTreatmentsQueryKey(patientId: string): readonly string[] {
  return ['patients', patientId, 'performedTreatments'];
}

export function buildSessionNoteQueryKey(noteId: string): readonly string[] {
  return ['sessionNotes', noteId];
}

export function buildAppointmentSessionNoteQueryKey(appointmentId: string): readonly string[] {
  return ['appointments', appointmentId, 'sessionNote'];
}

export function buildLastDeviceSettingsQueryKey(
  patientId: string,
  treatmentId: string
): readonly string[] {
  return ['patients', patientId, 'lastDeviceSettings', treatmentId];
}

export function buildDeviceSettingsHistoryQueryKey(patientId: string): readonly string[] {
  return ['patients', patientId, 'deviceSettingsHistory'];
}

export function buildInvitationPreviewQueryKey(token: string): readonly string[] {
  return ['invitationPreview', token];
}

export function buildPatientFirstConsultationQueryKey(patientId: string): readonly string[] {
  return ['patients', patientId, 'firstConsultation'];
}

export function buildFirstConsultationVersionsQueryKey(consultationId: string): readonly string[] {
  return ['firstConsultations', consultationId, 'versions'];
}

export function buildOwnFirstConsultationQueryKey(patientId: string): readonly string[] {
  return ['ownFirstConsultation', patientId];
}

export function buildPatientTreatmentPlanQueryKey(patientId: string): readonly string[] {
  return ['patients', patientId, 'treatmentPlan'];
}

export function buildPatientTreatmentPlanVersionsQueryKey(patientId: string): readonly string[] {
  return ['patients', patientId, 'treatmentPlan', 'versions'];
}

export function buildTreatmentPlanVersionQueryKey(planId: string): readonly string[] {
  return ['treatmentPlans', planId];
}

export function buildPatientFilesQueryKey(patientId: string): readonly string[] {
  return ['patients', patientId, 'files'];
}

export function buildOwnPatientFilesQueryKey(patientId: string): readonly string[] {
  return ['ownPatients', patientId, 'files'];
}

export function buildPatientProgressSeriesQueryKey(patientId: string): readonly string[] {
  return ['patients', patientId, 'progressSeries'];
}

export function buildPatientProgressComparisonQueryKey(patientId: string): readonly string[] {
  return ['patients', patientId, 'progressComparison'];
}

export function buildSessionSummaryQueryKey(noteId: string): readonly string[] {
  return ['sessionNotes', noteId, 'summary'];
}

export function buildExerciseComplianceQueryKey(patientId: string): readonly string[] {
  return ['patients', patientId, 'exerciseCompliance'];
}

export function buildPatientIntakeSubmissionQueryKey(patientId: string): readonly string[] {
  return ['patients', patientId, 'intakeSubmission'];
}

export const BROADCASTS_QUERY_KEY = ['broadcasts'] as const;

export function buildOwnPetProgressQueryKey(patientId: string): readonly string[] {
  return ['ownPets', patientId, 'progress'];
}

export const WORKSPACE_ATTENTION_QUERY_KEY = ['workspaceAttention'] as const;
export const OWN_CLINIC_CONTACT_QUERY_KEY = ['ownClinicContact'] as const;

export const OWN_PET_CHANGE_REQUESTS_QUERY_KEY = ['ownPetChangeRequests'] as const;
export const WORKSPACE_PET_CHANGE_REQUESTS_QUERY_KEY = ['workspacePetChangeRequests'] as const;

export function buildOwnPetChangeRequestsQueryKey(
  patientId: string,
  status: string
): readonly string[] {
  return [...OWN_PET_CHANGE_REQUESTS_QUERY_KEY, patientId, status];
}

export function buildWorkspacePetChangeRequestsQueryKey(
  patientId: string,
  status: string
): readonly string[] {
  return [...WORKSPACE_PET_CHANGE_REQUESTS_QUERY_KEY, patientId, status];
}

export const OWN_PORTAL_SUMMARY_QUERY_KEY = ['ownPortalSummary'] as const;
export const HOST_WORKSPACE_QUERY_KEY = ['hostWorkspace'] as const;
export const WORKSPACE_EXPORT_QUERY_KEY = ['workspaceExport'] as const;
export const WORKSPACE_CLOSURE_QUERY_KEY = ['workspaceClosure'] as const;

export const ASSISTANT_CONVERSATIONS_QUERY_KEY = ['assistantConversations'] as const;
export const ASSISTANT_MESSAGES_QUERY_KEY = ['assistantMessages'] as const;
export const ASSISTANT_PULSE_QUERY_KEY = ['assistantPulse'] as const;
export const ASSISTANT_PREFERENCES_QUERY_KEY = ['assistantPreferences'] as const;

export function buildAssistantConversationsQueryKey(
  page: number,
  search: string
): readonly (string | number)[] {
  return [...ASSISTANT_CONVERSATIONS_QUERY_KEY, page, search];
}

export function buildAssistantMessagesQueryKey(conversationId: string): readonly string[] {
  return [...ASSISTANT_MESSAGES_QUERY_KEY, conversationId];
}

export const PLATFORM_ASSISTANT_CONFIGURATION_QUERY_KEY = [
  'platformAssistantConfiguration',
] as const;
export const WORKSPACE_ASSISTANT_CONFIGURATION_QUERY_KEY = [
  'workspaceAssistantConfiguration',
] as const;
export const TENANT_ASSISTANT_CONFIGURATION_QUERY_KEY = ['tenantAssistantConfiguration'] as const;

export function buildTenantAssistantConfigurationQueryKey(tenantId: string): readonly string[] {
  return [...TENANT_ASSISTANT_CONFIGURATION_QUERY_KEY, tenantId];
}

export const ASSISTANT_INSIGHTS_QUERY_KEY = ['assistantInsights'] as const;

export function buildAssistantInsightsSummaryQueryKey(
  filters: Record<string, string>
): readonly (string | Record<string, string>)[] {
  return [...ASSISTANT_INSIGHTS_QUERY_KEY, 'summary', filters];
}

export function buildAssistantInsightsWorkspacesQueryKey(
  filters: Record<string, string>,
  page: number,
  search: string
): readonly (string | number | Record<string, string>)[] {
  return [...ASSISTANT_INSIGHTS_QUERY_KEY, 'workspaces', filters, page, search];
}
